import _regeneratorRuntime from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
import { itemFromArray } from "../../../Utils/Utils";
export var Pusher = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Pusher, _ExternalInteractorBa);
  var _super = _createSuper(Pusher);
  function Pusher(container) {
    var _this;
    _classCallCheck(this, Pusher);
    _this = _super.call(this, container);
    _this.handleClickMode = function (mode) {
      if (mode !== "push") {
        return;
      }
      var container = _this.container;
      var options = container.actualOptions;
      var pushNb = options.interactivity.modes.push.quantity;
      if (pushNb <= 0) {
        return;
      }
      var pushOptions = options.interactivity.modes.push;
      var group = itemFromArray([undefined].concat(_toConsumableArray(pushOptions.groups)));
      var groupOptions = group !== undefined ? container.actualOptions.particles.groups[group] : undefined;
      container.particles.push(pushNb, container.interactivity.mouse, groupOptions, group);
    };
    return _this;
  }
  _createClass(Pusher, [{
    key: "isEnabled",
    value: function isEnabled() {
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function interact() {
        return _interact.apply(this, arguments);
      }
      return interact;
    }()
  }]);
  return Pusher;
}(ExternalInteractorBase);